import React from 'react';
import styled from 'styled-components';
import {TypographyChildrenProps} from './Typography';
import {CombinedTextColorProps, useCombinedTextColor} from 'epic-ue-theme';

interface TypographyHeading3Props {
    big?: boolean;
}

const Heading = styled.h3<TypographyHeading3Props & CombinedTextColorProps>`
    font-family: ${(p) => p.theme.fonts.brutal.regular};
    font-weight: 400;
    font-size: ${(p) => (p.big ? '26px' : '20px')};
    line-height: ${(p) => (p.big ? '34px' : '28px')};
    letter-spacing: 0;
    margin: 0;
    color: ${(p) => useCombinedTextColor(p.color)};

    ${(p) => p.theme.breakpoints.down('md')} {
        font-size: ${(p) => (p.big ? '22px' : '20px')};
        line-height: ${(p) => (p.big ? '30px' : '28px')};
    }
`;

export const TypographyHeading3 = ({
    children,
    big,
    color,
    as,
    className = ''
}: TypographyChildrenProps & TypographyHeading3Props): JSX.Element => {
    return (
        <Heading
            className={`heading h3 ${big ? 'big' : ''} ${className || ''}`}
            big={big}
            color={color}
            as={as}>
            {children}
        </Heading>
    );
};
